import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"attic"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 2C12 2 16.1773 7.7768 19 9.29434V21H5V9.29434C7.82225 7.77702 11.9988 2.00167 12 2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14 21L14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17L10 21L14 21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14 21L14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17L10 21L14 21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 21H3M5 21H19M5 21L5 10L19 10L19 21M21 21H19M3 10C3.45499 10 4.16875 9.74123 5 9.29433C7.82266 7.7768 12 2 12 2C12 2 16.1773 7.7768 19 9.29433C19.8312 9.74123 20.545 10 21 10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Attic = Vue.extend<IconProps>({
  name: 'AtticIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'attic',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Attic;
